/*
 * bundle-builder.js — "בנה מארז" product-page block.
 *
 * Renders quantity tiers, lets the customer fill each slot from a modal picker,
 * and posts the finished bundle as an items[] array to /cart/add.js.
 *
 * The tier percentages are display only — Shopify's automatic cart discounts do
 * the actual charging. See the header comment in snippets/bundle-builder.liquid.
 *
 * Self-contained on purpose: it never reaches into the theme's variant picker
 * DOM beyond a guarded, optional read of the product form's `id` input, so a
 * change to main-product.liquid can't break it.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ── money ─────────────────────────────────────────────────────────────── */

  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var value = cents / 100;

    function withDelimiters(num, precision, thousands, decimal) {
      var fixed = num.toFixed(precision);
      var parts = fixed.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = (format || '{{amount}}').match(placeholder);
    var name = match ? match[1] : 'amount';
    var formatted;

    switch (name) {
      case 'amount_no_decimals':
        formatted = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = withDelimiters(value, 2, "'", '.');
        break;
      default:
        formatted = withDelimiters(value, 2, ',', '.');
    }

    return (format || '{{amount}}').replace(placeholder, formatted);
  }

  /* ── component ─────────────────────────────────────────────────────────── */

  function BundleBuilder(root) {
    this.root = root;
    var node = root.querySelector('[data-bb-config]');
    if (!node) return;

    try {
      this.cfg = JSON.parse(node.textContent);
    } catch (e) {
      // A malformed catalogue must not take the product page down with it.
      if (window.console) console.warn('[bundle-builder] bad config JSON', e);
      return;
    }
    if (!this.cfg.tiers || !this.cfg.tiers.length) return;

    // These two carry {placeholder} tokens, so the Liquid side cannot supply a
    // `| default:` fallback for them (its lexer rejects braces inside a quoted
    // filter argument). Cover a merchant who clears the field here instead.
    var labels = this.cfg.labels || (this.cfg.labels = {});
    if (!labels.badgeFormat) labels.badgeFormat = 'חסכו {pct}%';
    if (!labels.summaryFormat) labels.summaryFormat = 'סה"כ {count} פריטים · {total} · חסכתם {save}';
    if (!labels.summaryFormatOne) labels.summaryFormatOne = 'סה"כ פריט אחד · {total}';
    if (!labels.progressFormat) labels.progressFormat = 'בחרו עוד {n} דגמים';
    if (!labels.progressFormatOne) labels.progressFormatOne = 'בחרו עוד דגם אחד';
    if (!labels.counterFormat) labels.counterFormat = '{i} מתוך {n}';

    this.tiersEl = root.querySelector('[data-bb-tiers]');
    this.errorEl = root.querySelector('[data-bb-error]');
    this.footerEl = root.querySelector('[data-bb-footer]');
    this.summaryEl = root.querySelector('[data-bb-summary]');
    this.submitEl = root.querySelector('[data-bb-submit]');
    if (!this.tiersEl) return;

    // Default tier: the one flagged in the editor, else the first.
    this.activeIndex = 0;
    for (var i = 0; i < this.cfg.tiers.length; i++) {
      if (this.cfg.tiers[i].def) { this.activeIndex = i; break; }
    }

    this.qty = this.cfg.tiers[this.activeIndex].qty;
    this.slots = [];
    this.modal = null;
    this.pendingSlot = null;
    this.justFilled = null;

    this.buildCatalogue();
    this.hasTabs = (this.cfg.collections || []).length > 1;
    this.activeTab = (this.hasTabs && !this.cfg.showAllTab) ? 0 : 'all';

    var self = this;
    if (this.submitEl) {
      this.submitEl.addEventListener('click', function () {
        self.addToCart(self.submitEl, self.cfg.tiers[self.activeIndex]);
      });
    }

    this.syncCurrentVariant();
    this.resetSlots();
    this.render();
    this.watchThemeVariant();
  }

  /*
   * Liquid emits one entry per (product, collection) pair, so a product sitting
   * in three collections arrives three times. Collapse to one card that answers
   * to every tab it belongs to — otherwise the "all" tab shows duplicates.
   */
  BundleBuilder.prototype.buildCatalogue = function () {
    var byId = {};
    var list = [];
    (this.cfg.products || []).forEach(function (p) {
      var tab = typeof p.c === 'number' ? p.c : 0;
      var seen = byId[p.id];
      if (seen) {
        if (seen.tabs.indexOf(tab) === -1) seen.tabs.push(tab);
        return;
      }
      var entry = { id: p.id, t: p.t, img: p.img, p: p.p, v: p.v, tabs: [tab] };
      byId[p.id] = entry;
      list.push(entry);
    });
    this.catalogue = list;
  };

  /* Slot 0 mirrors the product the customer is already looking at. */
  BundleBuilder.prototype.syncCurrentVariant = function () {
    var cur = this.cfg.current;
    var chosen = null;
    for (var i = 0; i < cur.v.length; i++) {
      if (cur.v[i].id === cur.sel) { chosen = cur.v[i]; break; }
    }
    if (!chosen) {
      for (var j = 0; j < cur.v.length; j++) {
        if (cur.v[j].a) { chosen = cur.v[j]; break; }
      }
    }
    this.currentVariant = chosen || cur.v[0] || null;
  };

  /* Best-effort: follow the theme's own variant picker without depending on it. */
  BundleBuilder.prototype.watchThemeVariant = function () {
    var self = this;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;

    var apply = function () {
      var id = parseInt(input.value, 10);
      if (!id) return;
      var cur = self.cfg.current;
      for (var i = 0; i < cur.v.length; i++) {
        if (cur.v[i].id === id) {
          self.currentVariant = cur.v[i];
          if (self.slots[0]) {
            self.slots[0].variantId = id;
            self.slots[0].variantTitle = cur.v[i].t;
            self.slots[0].price = cur.v[i].p;
          }
          self.render();
          return;
        }
      }
    };

    input.addEventListener('change', apply);
    // Dawn swaps the input's value programmatically, which fires no event.
    if (window.MutationObserver) {
      new MutationObserver(apply).observe(input, { attributes: true, attributeFilter: ['value'] });
    }
  };

  BundleBuilder.prototype.resetSlots = function () {
    var cur = this.cfg.current;
    var next = [];
    next.push({
      locked: true,
      productId: cur.id,
      title: cur.t,
      img: cur.img,
      variants: cur.v,
      variantId: this.currentVariant ? this.currentVariant.id : null,
      variantTitle: this.currentVariant ? this.currentVariant.t : '',
      price: this.currentVariant ? this.currentVariant.p : 0
    });
    for (var i = 1; i < this.qty; i++) {
      next.push(this.slots[i] || null);
    }
    this.slots = next;
  };

  BundleBuilder.prototype.unitPrice = function () {
    return this.currentVariant ? this.currentVariant.p : 0;
  };

  /*
   * 'never' rounds to whole currency BEFORE formatting, so a discounted 84.15
   * and a full 99.00 both render without decimals. The old behaviour stripped a
   * literal ".00", which left "84.15" next to "99" — two formats in one row.
   */
  BundleBuilder.prototype.money = function (cents) {
    var value = cents;
    if (this.cfg.decimals === 'never') value = Math.round(value / 100) * 100;
    var out = formatMoney(value, this.cfg.moneyFormat);
    if (this.cfg.decimals === 'never') out = out.replace(/([.,])00\b/, '');
    return out;
  };

  /* ── rendering ─────────────────────────────────────────────────────────── */

  BundleBuilder.prototype.render = function () {
    var self = this;
    var unit = this.unitPrice();
    this.tiersEl.innerHTML = '';

    this.cfg.tiers.forEach(function (tier, index) {
      var active = index === self.activeIndex;
      var perUnit = Math.round(unit * (100 - tier.disc) / 100);

      var card = document.createElement('div');
      card.className = 'bb-tier' + (active ? ' is-active' : '') + (tier.ribbon ? ' has-ribbon' : '');
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', active ? 'true' : 'false');
      card.tabIndex = 0;

      var html = '';
      if (tier.ribbon) html += '<span class="bb-ribbon">' + esc(tier.ribbon) + '</span>';

      html += '<div class="bb-tier-head">';
      html += '<span class="bb-radio" aria-hidden="true"></span>';
      html += '<span class="bb-tier-label">';
      html += '<span class="bb-tier-titlerow">';
      html += '<span class="bb-tier-title">' + esc(tier.title || (tier.qty + '')) + '</span>';
      if (tier.disc > 0) {
        html += '<span class="bb-badge">' +
          esc(self.cfg.labels.badgeFormat.replace('{pct}', tier.disc)) + '</span>';
      }
      html += '</span>';
      if (tier.sub) html += '<span class="bb-tier-sub">' + esc(tier.sub) + '</span>';
      html += '</span>';

      html += '<span class="bb-tier-prices">';
      if (self.cfg.priceDisplay === 'total') {
        html += '<span class="bb-price">' + esc(self.money(perUnit * tier.qty)) + '</span>';
        if (tier.disc > 0) {
          html += '<span class="bb-compare">' + esc(self.money(unit * tier.qty)) + '</span>';
        }
      } else {
        html += '<span class="bb-price">' + esc(self.money(perUnit)) + '</span>';
        if (tier.disc > 0) {
          html += '<span class="bb-compare">' + esc(self.money(unit)) + '</span>';
        }
      }
      // "84.15 ₪" on a 3-pack row is ambiguous on its own — say which it is.
      if (self.cfg.showPriceCaption) {
        var caption = self.cfg.priceDisplay === 'total'
          ? self.cfg.labels.priceCaptionTotal
          : self.cfg.labels.priceCaptionUnit;
        if (caption) html += '<span class="bb-price-caption">' + esc(caption) + '</span>';
      }
      html += '</span>';
      html += '</div>';

      card.innerHTML = html;

      if (active) card.appendChild(self.buildSlots(tier));

      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-bb-nested]')) return;
        self.selectTier(index);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          self.selectTier(index);
        }
      });

      self.tiersEl.appendChild(card);
    });

    this.syncFooter();
  };

  BundleBuilder.prototype.buildSlots = function (tier) {
    var self = this;
    var wrap = document.createElement('div');
    wrap.className = 'bb-slots';
    wrap.setAttribute('data-bb-nested', '');

    if (tier.open && this.cfg.showStepper) {
      var step = document.createElement('div');
      step.className = 'bb-stepper';
      step.innerHTML =
        '<button type="button" data-bb-dec aria-label="הפחתה">&minus;</button>' +
        '<output>' + this.qty + '</output>' +
        '<button type="button" data-bb-inc aria-label="הוספה">+</button>';
      step.querySelector('[data-bb-dec]').disabled = this.qty <= tier.qty;
      step.querySelector('[data-bb-inc]').disabled = this.qty >= this.cfg.stepperMax;
      step.querySelector('[data-bb-dec]').addEventListener('click', function () {
        self.setQty(self.qty - 1, tier.qty);
      });
      step.querySelector('[data-bb-inc]').addEventListener('click', function () {
        self.setQty(self.qty + 1, tier.qty);
      });
      wrap.appendChild(step);
    }

    for (var i = 0; i < this.qty; i++) {
      wrap.appendChild(this.buildSlotRow(i));
    }

    // Summary and submit are NOT built here — they live once in the block
    // footer, so the CTA keeps its place when the customer switches tier.
    return wrap;
  };

  BundleBuilder.prototype.syncFooter = function () {
    var tier = this.cfg.tiers[this.activeIndex];
    var complete = this.isComplete();

    if (this.summaryEl) this.summaryEl.innerHTML = this.summaryHTML(tier);
    if (this.submitEl) {
      this.submitEl.textContent = complete ? this.cfg.labels.atc : this.cfg.labels.atcIncomplete;
      this.submitEl.disabled = !complete;
    }
    if (this.footerEl) this.footerEl.classList.toggle('is-ready', complete);
  };

  BundleBuilder.prototype.buildSlotRow = function (index) {
    var self = this;
    var slot = this.slots[index];

    if (!slot) {
      var empty = document.createElement('button');
      empty.type = 'button';
      empty.className = 'bb-slot-empty';
      empty.innerHTML =
        '<span class="bb-plus" aria-hidden="true">+</span>' +
        '<span class="bb-slot-empty-label">' + esc(this.cfg.labels.add) + '</span>';
      empty.addEventListener('click', function () { self.openModal(index); });
      return empty;
    }

    var row = document.createElement('div');
    row.className = 'bb-slot' + (index === this.justFilled ? ' is-just-filled' : '');

    var img = slot.img
      ? '<img class="bb-slot-img" src="' + esc(slot.img) + '" alt="" loading="lazy" width="64" height="64">'
      : '<span class="bb-slot-img"></span>';

    var sizeControl = '';
    var pickable = (slot.variants || []).filter(function (v) { return v.a; });
    if (slot.variants && slot.variants.length > 1) {
      sizeControl = '<select class="bb-slot-size" data-bb-size aria-label="' +
        esc(this.cfg.labels.chooseSize) + '">';
      slot.variants.forEach(function (v) {
        sizeControl += '<option value="' + v.id + '"' +
          (v.id === slot.variantId ? ' selected' : '') +
          (v.a ? '' : ' disabled') + '>' +
          esc(v.t) + (v.a ? '' : ' — ' + esc(self.cfg.labels.soldOut)) +
          '</option>';
      });
      sizeControl += '</select>';
    } else if (slot.variantTitle && slot.variantTitle !== 'Default Title') {
      sizeControl = '<div class="bb-tier-sub">' + esc(slot.variantTitle) + '</div>';
    }

    row.innerHTML =
      img +
      '<span class="bb-slot-body">' +
        '<span class="bb-slot-title">' + esc(slot.title) + '</span>' +
        sizeControl +
      '</span>' +
      (slot.locked ? '' :
        '<button type="button" class="bb-slot-change" data-bb-change>' +
        esc(this.cfg.labels.change) + '</button>');

    var select = row.querySelector('[data-bb-size]');
    if (select) {
      select.addEventListener('change', function () {
        var id = parseInt(select.value, 10);
        for (var i = 0; i < slot.variants.length; i++) {
          if (slot.variants[i].id === id) {
            slot.variantId = id;
            slot.variantTitle = slot.variants[i].t;
            slot.price = slot.variants[i].p;
            break;
          }
        }
        self.render();
      });
    }

    var change = row.querySelector('[data-bb-change]');
    if (change) {
      change.addEventListener('click', function () { self.openModal(index); });
    }

    if (!pickable.length) row.style.opacity = '.5';
    return row;
  };

  /*
   * While the bundle is incomplete this shows what is still missing. It used to
   * show a running total, which read as the price of a bundle the customer had
   * not actually built — and contradicted the button right below it.
   */
  BundleBuilder.prototype.summaryHTML = function (tier) {
    var subtotal = 0;
    var count = 0;
    for (var i = 0; i < this.qty; i++) {
      var slot = this.slots[i];
      if (slot && slot.variantId) { subtotal += slot.price; count += 1; }
    }

    var missing = this.qty - count;
    if (missing > 0) {
      var tpl = missing === 1 ? this.cfg.labels.progressFormatOne : this.cfg.labels.progressFormat;
      return esc(tpl).replace('{n}', '<strong>' + missing + '</strong>');
    }

    var total = Math.round(subtotal * (100 - tier.disc) / 100);
    var save = subtotal - total;
    var format = count === 1 ? this.cfg.labels.summaryFormatOne : this.cfg.labels.summaryFormat;

    return esc(format)
      .replace('{count}', '<strong>' + count + '</strong>')
      .replace('{total}', '<strong>' + esc(this.money(total)) + '</strong>')
      .replace('{save}', '<strong>' + esc(this.money(save)) + '</strong>')
      .replace('{pct}', tier.disc);
  };

  BundleBuilder.prototype.isComplete = function () {
    if (this.slots.length < this.qty) return false;
    for (var i = 0; i < this.qty; i++) {
      if (!this.slots[i] || !this.slots[i].variantId) return false;
    }
    return true;
  };

  /* ── interaction ───────────────────────────────────────────────────────── */

  BundleBuilder.prototype.selectTier = function (index) {
    if (index === this.activeIndex) return;
    this.activeIndex = index;
    this.qty = this.cfg.tiers[index].qty;
    this.clearError();
    this.resetSlots();
    this.render();
  };

  BundleBuilder.prototype.setQty = function (next, min) {
    var capped = Math.max(min, Math.min(this.cfg.stepperMax, next));
    if (capped === this.qty) return;
    this.qty = capped;
    this.resetSlots();
    this.render();
  };

  /* ── modal ─────────────────────────────────────────────────────────────── */

  BundleBuilder.prototype.openModal = function (slotIndex) {
    var self = this;
    this.pendingSlot = slotIndex;
    if (!this.modal) this.modal = this.buildModal();

    this.modal.classList.add('is-open');
    this.syncModalTitle();
    document.body.style.overflow = 'hidden';
    this.lastFocus = document.activeElement;

    var search = this.modal.querySelector('[data-bb-search]');
    if (search) { search.value = ''; this.filterModal(''); }

    var focusTarget = search || this.modal.querySelector('.bb-modal-close');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 30);

    this.escHandler = function (event) {
      if (event.key === 'Escape') self.closeModal();
      if (event.key === 'Tab') self.trapFocus(event);
    };
    document.addEventListener('keydown', this.escHandler);
  };

  BundleBuilder.prototype.closeModal = function () {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.escHandler);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  BundleBuilder.prototype.trapFocus = function (event) {
    var focusables = this.modal.querySelectorAll(
      'button:not(:disabled), input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  };

  BundleBuilder.prototype.buildModal = function () {
    var self = this;
    var el = document.createElement('div');
    el.className = 'bb-modal-' + this.cfg.uid;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', this.cfg.labels.modalTitle);

    var searchHTML = this.cfg.modalSearch
      ? '<input type="search" class="bb-modal-search" data-bb-search placeholder="' +
        esc(this.cfg.labels.searchPlaceholder) + '">'
      : '';

    el.innerHTML =
      '<div class="bb-modal-overlay" data-bb-overlay></div>' +
      '<div class="bb-modal-panel">' +
        '<div class="bb-modal-head">' +
          '<h4 class="bb-modal-title">' + esc(this.cfg.labels.modalTitle) + '</h4>' +
          '<button type="button" class="bb-modal-close" aria-label="סגירה">&times;</button>' +
        '</div>' +
        this.tabsHTML() +
        searchHTML +
        '<div class="bb-modal-body"><div class="bb-grid" data-bb-grid></div>' +
        '<p class="bb-empty bb-hidden" data-bb-empty>' + esc(this.cfg.labels.noResults) + '</p></div>' +
      '</div>';

    el.querySelector('[data-bb-overlay]').addEventListener('click', function () { self.closeModal(); });
    el.querySelector('.bb-modal-close').addEventListener('click', function () { self.closeModal(); });

    var search = el.querySelector('[data-bb-search]');
    if (search) {
      search.addEventListener('input', function () { self.filterModal(search.value); });
    }

    Array.prototype.forEach.call(el.querySelectorAll('[data-bb-tab]'), function (tab) {
      tab.addEventListener('click', function () {
        var value = tab.getAttribute('data-bb-tab');
        self.activeTab = value === 'all' ? 'all' : parseInt(value, 10);
        Array.prototype.forEach.call(el.querySelectorAll('[data-bb-tab]'), function (other) {
          other.classList.toggle('is-active', other === tab);
        });
        // Switching category clears the query — a stale term reads as an empty tab.
        if (search) search.value = '';
        self.filterModal('');
      });
    });

    this.renderModalGrid(el.querySelector('[data-bb-grid]'));
    document.body.appendChild(el);
    return el;
  };

  /* A single tab is no tab: with one collection the bar is pure noise. */
  BundleBuilder.prototype.tabsHTML = function () {
    if (!this.hasTabs) return '';
    var self = this;
    var html = '<div class="bb-tabs" role="tablist">';
    if (this.cfg.showAllTab) {
      html += '<button type="button" class="bb-tab is-active" data-bb-tab="all" role="tab">' +
        esc(this.cfg.allTabLabel || 'הכל') + '</button>';
    }
    this.cfg.collections.forEach(function (col, index) {
      var active = (!self.cfg.showAllTab && index === 0) ? ' is-active' : '';
      html += '<button type="button" class="bb-tab' + active + '" data-bb-tab="' + index +
        '" role="tab">' + esc(col.label) + '</button>';
    });
    return html + '</div>';
  };

  BundleBuilder.prototype.renderModalGrid = function (grid) {
    var self = this;
    grid.innerHTML = '';

    this.catalogue.forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'bb-pcard';
      card.setAttribute('data-bb-name', (p.t || '').toLowerCase());
      card.setAttribute('data-bb-tabs', p.tabs.join(' '));

      var img = p.img
        ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="200" height="200">'
        : '<span></span>';

      var sizes = '<div class="bb-sizes">';
      p.v.forEach(function (v) {
        var label = (v.t && v.t !== 'Default Title') ? v.t : self.cfg.labels.add;
        sizes += '<button type="button" class="bb-size" data-vid="' + v.id + '"' +
          (v.a ? '' : ' disabled') + '>' + esc(label) + '</button>';
      });
      sizes += '</div>';

      card.innerHTML =
        img +
        '<span class="bb-pcard-title">' + esc(p.t) + '</span>' +
        '<span class="bb-pcard-price">' + esc(self.money(p.p)) + '</span>' +
        sizes;

      card.querySelectorAll('.bb-size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.choose(p, parseInt(btn.dataset.vid, 10));
        });
      });

      grid.appendChild(card);
    });
  };

  BundleBuilder.prototype.filterModal = function (term) {
    var needle = (term || '').trim().toLowerCase();
    var tab = this.activeTab;
    var cards = this.modal.querySelectorAll('.bb-pcard');
    var shown = 0;
    cards.forEach(function (card) {
      var inTab = tab === 'all' ||
        card.getAttribute('data-bb-tabs').split(' ').indexOf(String(tab)) !== -1;
      var hit = inTab && (!needle || card.getAttribute('data-bb-name').indexOf(needle) !== -1);
      card.style.display = hit ? '' : 'none';
      if (hit) shown += 1;
    });
    var empty = this.modal.querySelector('[data-bb-empty]');
    if (empty) empty.classList.toggle('bb-hidden', shown > 0);
  };

  BundleBuilder.prototype.choose = function (product, variantId) {
    var variant = null;
    for (var i = 0; i < product.v.length; i++) {
      if (product.v[i].id === variantId) { variant = product.v[i]; break; }
    }
    if (!variant) return;

    this.slots[this.pendingSlot] = {
      locked: false,
      productId: product.id,
      title: product.t,
      img: product.img,
      variants: product.v,
      variantId: variant.id,
      variantTitle: variant.t,
      price: variant.p
    };

    this.clearError();
    this.justFilled = this.pendingSlot;
    this.render();
    this.flashFilledSlot();

    /*
     * Default is to close. Staying open saves a tap but gives the customer no
     * signal that anything happened — the modal looked identical after a pick,
     * which read as broken. Closing makes the filled row the confirmation.
     */
    if (this.cfg.closeOnPick !== false) {
      this.closeModal();
      return;
    }

    var nextEmpty = -1;
    for (var j = 0; j < this.qty; j++) {
      if (!this.slots[j]) { nextEmpty = j; break; }
    }
    if (nextEmpty === -1) {
      this.closeModal();
      return;
    }
    this.pendingSlot = nextEmpty;
    this.syncModalTitle();
    var search = this.modal.querySelector('[data-bb-search]');
    if (search) { search.value = ''; this.filterModal(''); }
  };

  BundleBuilder.prototype.flashFilledSlot = function () {
    var self = this;
    if (this.justFilled === null || this.justFilled === undefined) return;
    window.setTimeout(function () {
      self.justFilled = null;
      var node = self.tiersEl.querySelector('.bb-slot.is-just-filled');
      if (node) node.classList.remove('is-just-filled');
    }, 1500);
  };

  /* "בחרו מוצר · 2 מתוך 3" — which slot the customer is filling right now. */
  BundleBuilder.prototype.syncModalTitle = function () {
    if (!this.modal) return;
    var el = this.modal.querySelector('.bb-modal-title');
    if (!el) return;
    var base = this.cfg.labels.modalTitle;
    if (this.qty > 1) {
      base += ' · ' + this.cfg.labels.counterFormat
        .replace('{i}', this.pendingSlot + 1)
        .replace('{n}', this.qty);
    }
    el.textContent = base;
  };

  /* ── cart ──────────────────────────────────────────────────────────────── */

  BundleBuilder.prototype.addToCart = function (btn, tier) {
    var self = this;
    if (!this.isComplete()) return;

    // Merge duplicates so the cart shows one line of qty 2 rather than two lines.
    var merged = {};
    var order = [];
    for (var i = 0; i < this.qty; i++) {
      var id = this.slots[i].variantId;
      if (!merged[id]) { merged[id] = 0; order.push(id); }
      merged[id] += 1;
    }
    var items = order.map(function (id) {
      return { id: id, quantity: merged[id] };
    });

    var body = { items: items };
    var drawer = document.querySelector('cart-drawer');
    var sections = this.sectionsToRender(drawer);
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    this.clearError();

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          self.showError(data.description || data.message || self.cfg.labels.errorGeneric);
          return;
        }
        self.refreshCart(data, drawer, btn);
      })
      .catch(function () {
        self.showError(self.cfg.labels.errorGeneric);
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  };

  BundleBuilder.prototype.sectionsToRender = function (drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }
    return null;
  };

  BundleBuilder.prototype.refreshCart = function (data, drawer, btn) {
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
      drawer.renderContents(data);
      return;
    }

    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.renderContents === 'function' && data.sections) {
      notification.renderContents(data);
      return;
    }

    // No drawer and no notification component — fall back to the cart page.
    window.location = ROOT + 'cart';
  };

  BundleBuilder.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.classList.remove('bb-hidden');
  };

  BundleBuilder.prototype.clearError = function () {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.classList.add('bb-hidden');
  };

  /* ── util + boot ───────────────────────────────────────────────────────── */

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle-builder]').forEach(function (el) {
      if (el.dataset.bbReady === '1') return;
      el.dataset.bbReady = '1';
      new BundleBuilder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) { init(event.target); });
})();
